module.exports = __webpack_public_path__ + "img/tree-01-f-trunk.d50e7b1a.png";